//Website UI Components 
import NavMenu from '../section/LoggedInNav.js';

import SITELINKS from '../section/Footer.js';
import Banner from '../section/Title.js';
import Pdf from '../images/Yardi_Delayed_Payments_LL Memo_2025.pdf';
import Pdf2 from '../images/254790_Lot_A_Loan_Program_Brochure.pdf';

import LoginSteps from '../components/LoginSteps.js';
import AWSLoginSection from '../components/aws_login_component.js';
import AdditionalHelp from '../section/AdditionalHelp.js';

//boostrap resources 
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Modal from 'react-bootstrap/Modal';
import Spinner from 'react-bootstrap/Spinner';
import Button from 'react-bootstrap/Button';

import { useEffect, useState } from 'react';
import { useAuthenticator } from '@aws-amplify/ui-react';


/*Pending Things to Add

Instructions Component 
News Announcements Component
Previous Announcements Component 
Extra Information Component (how to use the site) 


AWS LOGIN SECTION IN RIGHT CONTENT DIV WILL BE MOVED TO ITS OWN FILE CALLED AWS_Login_Component

*/

const INFO_CARDS_STATE_STORAGE_KEY = 'public_info_cards_state_v1';

const DEFAULT_OPEN_INFO_IDS = {
  'payment-info': true,
  'portal-updates': true,
  announcements: true,
  support: true
};

const loadPersistedInfoCardsState = () => {
  try {
    const raw = localStorage.getItem(INFO_CARDS_STATE_STORAGE_KEY);
    if (!raw) {
      return null;
    }

    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch (error) {
    return null;
  }
};

const savePersistedInfoCardsState = (state) => {
  try {
    localStorage.setItem(INFO_CARDS_STATE_STORAGE_KEY, JSON.stringify(state));
  } catch (error) {
    // Ignore storage write failures.
  }
};


export const PublicPage = () => {
  const { isPending } = useAuthenticator((context) => [ context.isPending ]);
  const loading = isPending;
  const { user } = useAuthenticator((context) => [ context.user ]);
  const [openInfoIds, setOpenInfoIds] = useState(() => ({
    ...DEFAULT_OPEN_INFO_IDS,
    ...loadPersistedInfoCardsState()
  }));
  const [showDelayModal, setShowDelayModal] = useState(false);

  useEffect(() => {
    savePersistedInfoCardsState(openInfoIds);
  }, [openInfoIds]);

  const infoCards = [
    {
      id: 'payment-info',
      title: 'Payment Info',
      body: (
        <div className='text-center  loggedInBannerNoBg'>
          <br></br>
          <p className='emphTitle2 text-center'><b>LAST UPDATED: 08/04/2026</b></p>          
          <br></br>
          <h5 className='whiteFont'>SECTION 8 PAYMENTS: 08/01/2026</h5>
          <br></br>
          <h5 className='whiteFont'>MRVP PAYMENTS: 08/01/2026</h5>
          <br></br>          
          <h5 className='whiteFont'>HOMEBASE PAYMENTS: 08/03/2026</h5>
          <br></br>
          <h5 className='whiteFont'>WSD PAYMENTS: 07/09/2026</h5>
          <br></br>
        </div>
      )
    },
    {
      id: 'portal-updates',
      title: 'Portal Updates',
      body: (
        <ul className='emphBanner loggedInBannerNoBg whiteFont'>
          <br></br>
          
          <li>
            <p className='whiteFont'>
              Portal Updated with Payments up to 08/03/2026 in S8, MRVP, WSD and HOMEBASE.<br></br>
            </p>
          </li>
          <li className=''>
            <p className='whiteFont'>
              You can now search payments by check number on the Payments page.
            </p>
          </li>
          <li className=''>
            <p className='whiteFont '>
              You can now view your Properties on the Payments and Settings pages.<br></br>
            </p>
          </li>
        </ul>
      )
    },
    {
      id: 'announcements',
      title: 'Announcements',
      body: (
        <div className='emphBanner loggedInBannerNoBg whiteFont announcement-body'>
            <p>
              <a className='btn btn-primary buttons' href={Pdf} target='_blank' rel='noreferrer'>Smoke and Carbon Monoxide - 12/29/24</a>
            </p>
            <p className='whiteFont'>
              <Button 
                className='whiteFont wide btn delay-alert-btn' 
                onClick={() => setShowDelayModal(true)}
              >
                Delay in March Section 8 and MRVP Payments
              </Button>
              <p><i>Click Here for More Information</i></p>
            </p>
            <p><a className='btn btn-primary buttons' target='_blank' rel='noreferrer' href={Pdf2} >254790_Lot_A_Loan_Program_Brochure</a></p>
        </div>
      )
    },
    {
      id: 'support',
      title: 'Support & Help',
      body: (
        <div className='text-center  loggedInBannerNoBg'>
          <br></br>
          <p><a className='btn btn-primary buttons mt-2' target='_blank' rel='noreferrer' href='https://metrohousingboston.zendesk.com/hc/en-us'>Leased Housing Help Center</a></p>
          <p><a className='btn btn-primary buttons mt-2' target='_blank' rel='noreferrer' href='https://www.metrohousingboston.org/wp-content/uploads/2019/08/Direct-Deposit-Form-update-8.12.19-fillable-1.pdf'>Update Direct Deposit</a></p>
          <p><a className='btn btn-primary buttons mt-2' target='_blank' rel='noreferrer' href='mailto:portalhelp@mbhp.org?subject=[Technical Support]'>Submit Ticket</a></p>
          <p><a className='btn btn-primary buttons mt-2' target='_blank' rel='noreferrer' href='https://airtable.com/shrzMcypjWPdZaeLL'>Rent Increase Request</a></p>
          <br></br>
        </div>
      )
    }
  ];
  
  const userInfo = user ? (
    <div>
      <br />
      <h1 className='emphTitle'>User: {user.attributes?.given_name} {user.attributes?.family_name}</h1>
      <h6 className=' '>{user.attributes?.email}</h6>
      <p className='emphText'><em>You have successfully logged into the Metro Housing Boston Property Manager Portal</em></p>
    </div>
  ) : null;

  return (
    <div className='App public-page'>
      <NavMenu/>
      <Banner/>
      

      <div className='publicContent'>
        
        {user && (
          
          <Row>
            <Col xs={12} md={12} lg={12} xl={12}>
              <br />
              <h2 className='sectionTitle emphText'>Welcome to the Metro Housing Boston Property Manager Portal</h2>
              <hr />
            </Col>
          </Row>
        )}

        {user && (
          <Row>
            <Col xs={12} md={12} lg={12} xl={12}>
              {userInfo}
              <hr />
            </Col>
          </Row>  
        )}      

        {user && (
          <Row className='g-3 justify-content-center'>
            <Col xs={12} md={6} lg={3} xl={3} className='text-center nav-button-animate'>
              <Button
                variant='primary'
                size='lg'
                className='w-100 nav-square-button public-large-button'
                href='/payments'
              >
                PAYMENTS
              </Button>
            </Col>
            <Col xs={12} md={6} lg={3} xl={3} className='text-center nav-button-animate'>
              <Button
                variant='primary'
                size='lg'
                className='w-100 nav-square-button public-large-button'
                href='/documents'
              >
                DOCUMENTS
              </Button>
            </Col>
            <Col xs={12} md={6} lg={3} xl={3} className='text-center nav-button-animate'>
              <Button
                variant='primary'
                size='lg'
                className='w-100 nav-square-button public-large-button'
                href='/main'
              >
                MESSAGES
              </Button>
            </Col>
            <Col xs={12} md={6} lg={3} xl={3} className='text-center nav-button-animate'>
              <Button
                variant='primary'
                size='lg'
                className='w-100 nav-square-button public-large-button'
                href='/settings'
              >
                SETTINGS
              </Button>
            </Col>
            <br></br>
            <hr></hr>
          </Row>
        )}        

        {user && (      
          <Row className='g-3 justify-content-center'>
            {infoCards.map((card) => (
              <Col key={card.id} xs={12} md={6} lg={3} xl={3} className='text-center info-card-animate'>
                <Button
                  variant={openInfoIds[card.id] ? 'dark' : 'primary'}
                  size='lg'
                  className={`px-5 py-3 w-100 info-toggle-btn ${openInfoIds[card.id] ? 'info-toggle-btn-open' : 'info-toggle-btn-closed'}`}
                  onClick={() =>
                    setOpenInfoIds((prev) => ({
                      ...prev,
                      [card.id]: !prev[card.id]
                    }))
                  }
                >
                  {card.title} {openInfoIds[card.id] ? '(Hide)' : '(Show)'}
                </Button>
                <div className={`mt-3 info-card-body ${openInfoIds[card.id] ? 'is-open' : 'is-closed'}`}>
                  {card.body}
                </div>
              </Col>
            ))}
          </Row>
          
        )}

        <br></br>
        <hr></hr>

        {user && <AdditionalHelp/>}

        {
          
          <Row >
            <Col xs={12} md={12} lg={12} xl={6}>
              <div className='leftContent'>
                <LoginSteps/>
              </div>              
            </Col>
            <Col xs={12} md={12} lg={12} xl={6}>
              <div className='rightContent'> 
                <AWSLoginSection/>
              </div>            
            </Col>
          </Row>
        }
      </div>

      <SITELINKS/>

      <Modal show={loading} centered backdrop='static' keyboard={false}>
        <Modal.Body className='loading-modal-body'>
          <Spinner animation='border' role='status' className='loading-modal-spinner' />
          <div>Website Loading...</div>
        </Modal.Body>
      </Modal>

      <Modal show={showDelayModal} onHide={() => setShowDelayModal(false)} centered size='lg'>
        <Modal.Header closeButton>
          <Modal.Title>Payment Delay Notice</Modal.Title>
        </Modal.Header>
        <Modal.Body className='delay-modal-body'>
          <p><strong>There will be a delay in rental subsidy payments for the Section 8 and MRVP scheduled to be issued to property owners on March 1st. The Commonwealth of Massachusetts is transitioning to a new financial management system, which will require a one-week processing blackout period during which no transactions can be processed. As a result, payments from the Commonwealth of Massachusetts Executive Office of Housing and Livable Communities to Metro Housing and the Regional Administering Agencies (RAAs) will be delayed until March 3, and subsidy payment(s) may be received a few days later than usual.</strong></p>
          <p><strong>EOHLC and the RAAs are prioritizing the timely release of all payments and apologize for any inconvenience this may cause, particularly following the recent voucher software transition. We greatly value your partnership in providing stable housing and appreciate your patience during this period of transition. We remain fully committed to ensuring accurate and timely payments and to supporting you in the essential role you play in our housing programs.</strong></p>
          <p><strong>There has been a change regarding the process for requesting rent increases. Contract rent increase requests may only be submitted using this <a href='https://airtable.com/shrzMcypjWPdZaeLL' target='_blank' rel='noreferrer'>LINK</a>. For more information, please visit <a href='https://conta.cc/3Oe9szf' target='_blank' rel='noreferrer'>HERE</a>. As of February 15, 2024, Metro Housing is no longer providing an apartment search service its website.There have recently been an increasing number of tenants who have been victimized by fake apartment listings on our website. Tracking and certifying honest apartment postings has become more time consuming and fraught with possible fraud.</strong></p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='primary' onClick={() => setShowDelayModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

    </div>
  );
};